"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountInfoReadForm = void 0;
var React = require("react");
var LoginState_1 = require("@/pages/common/states/LoginState");
var AccountInfoState_1 = require("@/pages/accountInfo/states/AccountInfoState");
var AccountInfoReadForm = function (props) {
    var _a = props.account, email = _a.email, firstname = _a.firstname, lastname = _a.lastname, salutation = _a.salutation, birthdayDate = _a.birthdayDate, registerDate = _a.registerDate, phone = _a.phone, from = _a.from, language = _a.language, currency = _a.currency;
    var renderEmail = function (props, from, email) {
        if (from === AccountInfoState_1.RegisterFrom.NONE) {
            return (React.createElement("div", { className: "c-readform__value" }, email));
        }
        return (React.createElement("div", { className: "c-readform__value" },
            props.t.nameConnectedWith,
            " \u00A0",
            React.createElement("span", { className: "o-tag o-tag--facebook" }, props.t.nameFacebook)));
    };
    var renderName = function (firstname, lastname, salutation) {
        var name = '';
        if (salutation !== LoginState_1.Salutation.NONE) {
            name = LoginState_1.salutationMap[salutation];
        }
        if (firstname) {
            name = name + " " + firstname;
        }
        if (lastname) {
            name = name + " " + lastname;
        }
        return (React.createElement("div", { className: "c-readform__value u-capfirst" }, name));
    };
    var renderPhone = function (props, phone) {
        if (!phone.body) {
            return (React.createElement("div", { className: "c-readform__value c-readform__value--na" }, props.t.nameNA));
        }
        return (React.createElement("div", { className: "c-readform__value" },
            phone.code ? "+" + phone.code : '',
            " ",
            phone.body));
    };
    var renderBirthday = function (props, birthday) {
        var date = new Date(birthday.replace(/-/g, '/'));
        if (date.getFullYear() < 1900) {
            return (React.createElement("div", { className: "c-readform__value c-readform__value--na" }, props.t.nameNA));
        }
        var birthdayString = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        return (React.createElement("div", { className: "c-readform__value" }, birthdayString));
    };
    var renderMemberSince = function (props, memberSince) {
        var date = new Date(memberSince.replace(/-/g, '/'));
        if (!date || date.getFullYear() < 1900) {
            return (React.createElement("div", { className: "c-readform__value c-readform__value--na" }, props.t.nameNA));
        }
        var memberSinceString = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        return (React.createElement("div", { className: "c-readform__value" }, memberSinceString));
    };
    var renderLanguage = function (props, language) {
        var currentLanguageName = props.languageMap.find(function (it) { return it.id === language; }).name;
        return (React.createElement("div", { className: "c-readform__value" }, currentLanguageName));
    };
    var renderCurrency = function (props, currency) {
        var currentCurrencySymbol = props.currencyOptions.find(function (it) { return it.key === currency; }).symbol;
        return (React.createElement("div", { className: "c-readform__value" }, currentCurrencySymbol));
    };
    return (React.createElement("div", { className: "c-readform", style: { maxWidth: 700 } },
        React.createElement("div", { className: "c-readform__row" },
            React.createElement("span", { className: "c-readform__tag" },
                props.t.nameName,
                ": "),
            renderName(firstname, lastname, salutation)),
        React.createElement("div", { className: "c-readform__row" },
            React.createElement("span", { className: "c-readform__tag" },
                props.t.nameEmail,
                ": "),
            renderEmail(props, from, email)),
        React.createElement("div", { className: "c-readform__row" },
            React.createElement("span", { className: "c-readform__tag" },
                props.t.namePhone,
                ": "),
            renderPhone(props, phone)),
        React.createElement("div", { className: "c-readform__row" },
            React.createElement("span", { className: "c-readform__tag" },
                props.t.nameLanguage,
                ": "),
            renderLanguage(props, language)),
        React.createElement("div", { className: "c-readform__row" },
            React.createElement("span", { className: "c-readform__tag" },
                props.t.nameCurrency,
                ": "),
            renderCurrency(props, currency)),
        React.createElement("div", { className: "c-readform__row" },
            React.createElement("span", { className: "c-readform__tag" },
                props.t.nameBirthday,
                ": "),
            renderBirthday(props, birthdayDate)),
        React.createElement("div", { className: "c-readform__row" },
            React.createElement("span", { className: "c-readform__tag" },
                props.t.nameMemberSince,
                ": "),
            renderMemberSince(props, registerDate)),
        React.createElement("div", { className: "c-readform__row", style: { borderBottom: 'none' } },
            React.createElement("div", { className: "c-readform__actions" },
                React.createElement("button", { className: "o-btn o-btn--primary o-btn--long", onClick: props.onEditClick }, props.t.nameEdit),
                React.createElement("button", { className: "o-textbtn", onClick: props.onDeleteAccountClick }, props.t.nameDeleteAccount)))));
};
exports.AccountInfoReadForm = AccountInfoReadForm;
